import styled from 'styled-components';
import {Checkbox as CheckboxComponent} from '@guestapp/ui';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Checkbox = styled(CheckboxComponent)`
  align-items: start;

  & .checkbox__label {
    font-size: 14px;
    font-weight: 400;
  }

  & ~ .error-message {
    left: 0px;
    text-align: left;
  }
`;
